import { B2C_FEATURE_FLAGS } from "@/shared/config/FeatureFlags.config";
import { whiteLabelContent as standardContent } from "./content";
import { whiteLabelOcContent } from "./content.oc";
import { whiteLabelResources } from "./resources";
import { applyWhiteLabelTheme, whiteLabelTheme } from "./theme";

const whiteLabelContent = B2C_FEATURE_FLAGS.isOCEnvironment ? whiteLabelOcContent : standardContent;

const whiteLabelBundle = {
  config: {
    ...whiteLabelContent,
    theme: whiteLabelTheme,
  },
  resources: whiteLabelResources,
  applyTheme: applyWhiteLabelTheme,
  getWhatsAppUrl() {
    return `https://wa.me/${whiteLabelContent.contact.whatsappNumber}`;
  },
  isImageLogoPath(path?: string | null) {
    if (!path) return false;
    return /\.(png|webp|svg|jpg|jpeg|gif|avif)$/i.test(path.trim());
  },
} as const;

export { whiteLabelBundle };
export default whiteLabelBundle;
